
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "DiagnosticCriteriaForCrohnsDisease",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DiagnosticCriteriaForCrohnsDisease.vue